import { render, staticRenderFns } from "./DiseaseManagement.vue?vue&type=template&id=3b3bc466&scoped=true"
import script from "./DiseaseManagement.vue?vue&type=script&lang=js"
export * from "./DiseaseManagement.vue?vue&type=script&lang=js"
import style0 from "./DiseaseManagement.vue?vue&type=style&index=0&id=3b3bc466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bc466",
  null
  
)

export default component.exports